import { usePlausible } from 'next-plausible';
import { useRef, useState } from 'react';
import BlogName from './BlogName';

const FeaturedComponent = ({ setNameOpen }) => {
  const [loading, setLoading] = useState(false);
  const [names, setNames] = useState(undefined);
  const [keywords, setKeywords] = useState('');
  const [moreLoading, setMoreLoading] = useState(false);
  const plausible = usePlausible();
  const tracked = useRef(false);

  async function handleGenerateNames(isMore) {
    if (!tracked.current) {
      tracked.current = true;
      plausible('Name Generator Used');
    }
    if (!isMore) setNames(undefined);
    if (isMore) setMoreLoading(true);
    else setLoading(true);
    const response = await fetch(
      `/api/name-generator?keywords=${encodeURIComponent(keywords)}`,
    ).catch(err => {
      console.log(err);
    });
    const res = await response.json().catch(err => {
      console.error(err);
      if (isMore) setMoreLoading(false);
      else setLoading(false);
    });
    if (
      res &&
      res.status === 'success' &&
      res.message &&
      res.message.length > 0
    ) {
      setNames(isMore ? [...names, ...res.message] : res.message);
    }
    if (isMore) setMoreLoading(false);
    else setLoading(false);
  }

  function handleKeywordInput(e) {
    if (e.key === 'Enter') handleGenerateNames(false);
  }

  return (
    <section className="tw-bg-gradient-to-b tw-from-primary-100 tw-to-gray-50 tw-py-10 sm:tw-py-16 lg:tw-py-32">
      <div className="tw-px-4 tw-mx-auto tw-max-w-7xl sm:tw-px-6 lg:tw-px-8">
        <div className="tw-max-w-2xl tw-mx-auto tw-text-center">
          <h1 className="tw-text-4xl tw-font-bold tw-leading-tight tw-text-black sm:tw-text-5xl lg:tw-text-6xl">
            <span className="tw-text-primary-800">Travel Blog</span> Name Ideas
            Generator
          </h1>
          <p className="tw-max-w-lg tw-mx-auto tw-mt-4 tw-text-base tw-leading-relaxed tw-text-gray-600">
            Type a word or two you want in your travel blog name. With just one
            click, you will get a list of travel blog name ideas instantly.
          </p>
          <div className="tw-mt-12 tw-flex tw-items-center tw-justify-center shadow-sm">
            <input
              type="text"
              placeholder="Enter keywords..."
              className="tw-text-base tw-py-4 tw-border-none	tw-w-full tw-px-3 tw-rounded-tl tw-rounded-bl focus:tw-outline-none"
              maxLength={40}
              value={keywords}
              onKeyDown={handleKeywordInput}
              onChange={e => setKeywords(e.target.value)}
            />
            <button
              className="tw-py-4 tw-text-base tw-bg-primary-500 tw-text-white tw-rounded-tr tw-rounded-br hover:tw-bg-primary-600 tw-shrink-0 tw-px-4 tw-border-none tw-font-semibold focus:tw-bg-primary-700"
              onClick={() => handleGenerateNames(false)}
              role="button"
              tabIndex={0}
            >
              {loading ? 'Loading...' : 'Generate Names'}
            </button>
          </div>
        </div>
        {names && names.length > 0 && (
          <>
            <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-2 sm:tw-gap-4 tw-pt-16">
              {names.map(blogName => (
                <BlogName
                  key={blogName}
                  name={blogName}
                  setNameOpen={setNameOpen}
                />
              ))}
            </div>
            <div className="text-center tw-mt-8">
              <button
                className="tw-bg-primary-500 tw-rounded tw-text-white tw-border-none tw-px-4 tw-py-3 tw-text-base tw-font-semibold hover:tw-bg-primary-600 focus:tw-bg-primary-700"
                onClick={() => handleGenerateNames(true)}
                role="button"
                tabIndex={0}
              >
                {moreLoading ? 'Loading...' : 'Generate More'}
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default FeaturedComponent;
